import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { take } from 'rxjs/operators';

const SERVICE = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class RegisterService {

    constructor(private http: HttpClient) {}

    save(cadastroDto): Observable<any> {
        return this.http.post(`${SERVICE}/usuario/cadastrar`, cadastroDto).pipe(take(1));
    }
    
}